export const fieldNameMapping = {
  applicationAmountMinimum: 'applicationMinimumAmount',
  applicationAmountMaximum: 'applicationMaximumAmount',

  daysToRedemptionMinimum: 'minimumDaysToRedemption',
  daysToRedemptionMaximum: 'maximumDaysToRedemption',

  redemptionDaysMinimum: 'minimumRedemptionDays',
  redemptionDaysMaximum: 'maximumRedemptionDays',

  privatePensionSettlementPeriodMinimum: 'initialMonthsToExpire',
  privatePensionSettlementPeriodMaximum: 'finalMonthsToExpire',

  legacyInitialApplicationMinimum: 'applicationMinimumAmount',
  legacyInitialApplicationMaximum: 'applicationMaximumAmount',

  commonDateRangeMinimum: 'startDate',
  commonDateRangeMaximum: 'endDate',

  sendDateMinimum: 'sendDateStart',
  sendDateMaximum: 'sendDateEnd',

  hiringDateMinimum: 'startAcceptationDate',
  hiringDateMaximum: 'endAcceptationDate',

  feeAmountMinimum: 'minAnnualPercentage',
  feeAmountMaximum: 'maxAnnualPercentage',
};
